document.addEventListener('click', async (event) => {
  const target = event.target;

  if (!(target instanceof Element)) return;

  const trigger = target.closest('.js-cookie-preferences');

  if (!(trigger instanceof HTMLAnchorElement)) return;

  event.preventDefault();

  if (typeof window.privacyBanner?.showPreferences === 'function') {
    await window.privacyBanner.showPreferences();
  }
});
